module.exports = __webpack_public_path__ + "static/img/checklist.d70721b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checklist.png
// module id = 7akU
// module chunks = 0